import { InflatedListItemProduct, Room } from './ListTypes'
import FirebaseApp from '../FirebaseApp'
import { CloudListItemProduct, CloudRoom } from '../types/CloudSharedList'

export function saveSharedListToFirestore(
  listName: string,
  rooms: readonly Room[],
  configuredProducts: readonly InflatedListItemProduct[],
): Promise<string> {
  const db = FirebaseApp.firestore()
  const batch = db.batch()
  const listDoc = db.collection('sharedLists').doc()

  batch.set(listDoc, {
    name: listName,
  })

  const roomsCollection = listDoc.collection('rooms')

  rooms.forEach((room, i) => {
    const roomDoc = roomsCollection.doc()

    const { name, uid } = room

    const cloudRoom: CloudRoom = {
      name,
      uid,
      order: i,
    }

    batch.set(roomDoc, cloudRoom)
  })

  const configuredProductsCollection = listDoc.collection('products')

  configuredProducts.forEach((product, i) => {
    const productDoc = configuredProductsCollection.doc()

    const cloudProduct: CloudListItemProduct = {
      ...product,
      order: i,
    }

    batch.set(productDoc, cloudProduct)
  })

  return batch.commit()
    .then(() => listDoc.id)
    .catch(err => {
      console.error(err)
      throw err
    })
}